<template>
  <div v-redirect-if-no-permission:DRIVERS>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-inline-start: 20px">
        <v-form ref="form"><img :src="imageFile ? imageUrl : api.GET_IMAGE(captain.profile_image)" class="image"
            @click="$refs.image.click()" />
          <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ this.captain.first_name }} {{ this.captain.last_name }} (<span class="fa fa-star star"></span>
            <span class="star"> {{ this.captain.rating }} </span>)
          </div>
          <div style="color: #8599a3">{{ this.captain.email }}</div>
          <div style="color: #8599a3; margin-top: 6px">
            {{ $companyTime(captain.created_at, "YYYY-MM-DD") }}
          </div>
        </v-flex>

        <v-flex xs2>
          <div>
            <v-switch v-if="!vSwitchLoading && captain.approved_at" v-model="blackListed" :label="blackListedTag"
              @change="blockCaptain" color="red"></v-switch>
            <!-- Owner item 3.1: the driver's account state, as on the drivers list. -->
            <v-chip v-if="captain.approved_at && captainAccountState" small text-color="white" class="ms-0"
              :color="captainAccountStateColor">
              {{ $t("accountState." + captainAccountState) }}
            </v-chip>
            <div v-if="captain.approved_at && blackListed && captain.blacklist_note" class="ban-note">
              {{ $t("accountState.noteLabel") }}: {{ captain.blacklist_note }}
            </div>
          </div>
        </v-flex>
        <!-- Welcome bonus (doc 28-8): editable while pending; after the grant
             the restricted balance card below the header takes over. Owner
             item 2.1: a whole old-unit amount (at most two decimals shown) up to the settings ceiling,
             and changing it needs WELCOME_BONUS_MANAGE. -->
        <v-flex xs3 v-if="!captain.approved_at && captain.welcome_bonus_enabled">
          <v-text-field v-model="welcomeBonusInput" type="number" min="0" step="0.01"
            :max="welcomeBonusMax > 0 ? welcomeBonusMax / 100 : undefined" class="me-3"
            :disabled="!canSetWelcomeBonus" :rules="welcomeBonusRules"
            :label="$t('captainProfilePage.profile.welcomeBonusLabel')"
            :hint="welcomeBonusInputHint" persistent-hint></v-text-field>
        </v-flex>
        <v-flex xs2>
          <div>
            <v-btn v-if="!captain.approved_at" @click="register" :loading="registerLoading" style="float: inline-end"
              color="primary">{{ $t("captainProfilePage.profile.accept") }}</v-btn>
          </div>
        </v-flex>

      </v-layout>
      <!-- Owner item 2.1: the restricted welcome balance (granted / used /
           remaining / expiry / status), its close-approve controls and its
           movements. -->
      <WelcomeBonusCard v-if="captain.welcome_bonus_summary || captain.welcome_bonus_granted_at"
        :captain-id="Number($route.params.id)" :summary="captain.welcome_bonus_summary"
        :granted-amount="captain.welcome_bonus" :granted-at="captain.welcome_bonus_granted_at"
        :legacy-status="captain.welcome_bonus_status" @summary="onWelcomeBonusSummary" />
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab"> {{ $t("captainProfilePage.profile.tabDriver") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
            <v-layout align-start>
              <v-flex xs6 style="height: 100%; margin-inline-start: 100px">
                <v-card-title primary-title>
                  <v-flex xs12 style="margin-bottom: 25px">
                    <div class="headline">{{ $t("captainProfilePage.profile.information") }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <table class="info-table">
                      <tr>
                        <td>{{ $t("captainProfilePage.common.firstName") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.first_name_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.common.firstName")'
                            :disabled="!this.editHolder.first_name" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.first_name = true" v-if="!this.editHolder.first_name">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.first_name = false;
                          editHolder.first_name_value =
                            captain.first_name;
                          " v-if="this.editHolder.first_name">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.first_name = false" v-if="this.editHolder.first_name">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.common.lastName") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.last_name_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.common.lastName")'
                            :disabled="!this.editHolder.last_name" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.last_name = true" v-if="!this.editHolder.last_name">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.last_name = false;
                          editHolder.last_name_value =
                            captain.last_name;
                          " v-if="this.editHolder.last_name">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.last_name = false" v-if="this.editHolder.last_name">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>

                      <tr>
                        <td>{{ $t("captainProfilePage.profile.phoneNumber") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.username_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.profile.phoneNumber")'
                            :disabled="!this.editHolder.username" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.username = true" v-if="!this.editHolder.username">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.username = false;
                          editHolder.username_value =
                            captain.phone_number;
                          " v-if="this.editHolder.username">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.username = false" v-if="this.editHolder.username">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>

                      <tr>
                        <td>{{ $t("captainProfilePage.profile.email") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.email_value" style="float: inline-start; width: calc(100% - 128px)"
                            :label='$t("captainProfilePage.profile.email")' :disabled="!this.editHolder.email">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.email = true" v-if="!this.editHolder.email">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.email = false;
                          editHolder.email_value =
                            captain.phone_number;
                          " v-if="this.editHolder.email">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.email = false" v-if="this.editHolder.email">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>


                      <tr>
                        <td>{{ $t("captainProfilePage.profile.type") }}</td>
                        <td>
                          <v-select v-model="editHolder.type_value" style="float: inline-start; width: calc(100% - 128px)"
                            :label='$t("captainProfilePage.profile.type")' :items="types" item-value="value" item-text="text"
                            :disabled="!this.editHolder.type">
                          </v-select>
                          <div>
                            <button @click="editHolder.type = true" v-if="!this.editHolder.type">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.type = false;
                          editHolder.type_value =
                            captain.type;
                          " v-if="this.editHolder.type">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.type = false" v-if="this.editHolder.type">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>

                      <tr>
                        <td>{{ $t("captainProfilePage.profile.gender") }}</td>
                        <td>
                          <v-select v-model="editHolder.gender_value" style="float: inline-start; width: calc(100% - 128px)"
                            :label='$t("captainProfilePage.profile.gender")' :items="genders" item-value="value" item-text="text"
                            :disabled="!this.editHolder.gender">
                          </v-select>
                          <div>
                            <button @click="editHolder.gender = true" v-if="!this.editHolder.gender">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.gender = false;
                          editHolder.gender_value =
                            captain.gender;
                          " v-if="this.editHolder.gender">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.gender = false" v-if="this.editHolder.gender">
                            <v-icon>check</v-icon>
                          </button>
                        </td>

                      </tr>


                    </table>
                  </v-flex>
                </v-card-title>
              </v-flex>
              <v-flex xs7 style="height: 100%">
                <v-card-title primary-title>
                  <v-flex xs12 style="margin-bottom: 16px">
                    <div class="headline">
                      {{ $t("captainProfilePage.profile.documents") }}
                      <input type="file" style="display: none" ref="lisence_photo_front_input" accept="image/*"
                        @change="onCaptainDocumentPicked($event, 'lisence_photo_front')" />
                      <input type="file" style="display: none" ref="lisence_photo_back_input" accept="image/*"
                        @change="onCaptainDocumentPicked($event, 'lisence_photo_back')" />
                      <input type="file" style="display: none" ref="id_card_front_input" accept="image/*"
                        @change="onCaptainDocumentPicked($event, 'id_card_front')" />
                      <input type="file" style="display: none" ref="id_card_back_input" accept="image/*"
                        @change="onCaptainDocumentPicked($event, 'id_card_back')" />
                    </div>
                    <div class="captain-doc-upload-buttons">
                      <button type="button" class="upload-button-inline" @click="triggerCaptainDocumentUpload('lisence_photo_front')">
                        {{ $t("captainProfilePage.profile.uploadLicenseFront") }}
                      </button>
                      <button type="button" class="upload-button-inline" @click="triggerCaptainDocumentUpload('lisence_photo_back')">
                        {{ $t("captainProfilePage.profile.uploadLicenseBack") }}
                      </button>
                      <button type="button" class="upload-button-inline" @click="triggerCaptainDocumentUpload('id_card_front')">
                        {{ $t("captainProfilePage.profile.uploadIdFront") }}
                      </button>
                      <button type="button" class="upload-button-inline" @click="triggerCaptainDocumentUpload('id_card_back')">
                        {{ $t("captainProfilePage.profile.uploadIdBack") }}
                      </button>
                    </div>
                    <div class="captain-doc-preview-list">
                      <div class="captain-doc-preview-item" v-if="captainDocumentImageUrls.lisence_photo_front">
                        <div class="captain-doc-preview-label">{{ $t("captainProfilePage.profile.licenseFront") }}</div>
                        <div class="car-image-wrapper">
                          <img class="car-image" :src="captainDocumentImageUrls.lisence_photo_front" height="100" />
                          <button type="button" class="remove-car-image-button"
                            @click="clearCaptainDocumentSelection('lisence_photo_front')">x</button>
                        </div>
                      </div>
                      <div class="captain-doc-preview-item" v-if="captainDocumentImageUrls.lisence_photo_back">
                        <div class="captain-doc-preview-label">{{ $t("captainProfilePage.profile.licenseBack") }}</div>
                        <div class="car-image-wrapper">
                          <img class="car-image" :src="captainDocumentImageUrls.lisence_photo_back" height="100" />
                          <button type="button" class="remove-car-image-button"
                            @click="clearCaptainDocumentSelection('lisence_photo_back')">x</button>
                        </div>
                      </div>
                      <div class="captain-doc-preview-item" v-if="captainDocumentImageUrls.id_card_front">
                        <div class="captain-doc-preview-label">{{ $t("captainProfilePage.profile.idCardFront") }}</div>
                        <div class="car-image-wrapper">
                          <img class="car-image" :src="captainDocumentImageUrls.id_card_front" height="100" />
                          <button type="button" class="remove-car-image-button"
                            @click="clearCaptainDocumentSelection('id_card_front')">x</button>
                        </div>
                      </div>
                      <div class="captain-doc-preview-item" v-if="captainDocumentImageUrls.id_card_back">
                        <div class="captain-doc-preview-label">{{ $t("captainProfilePage.profile.idCardBack") }}</div>
                        <div class="car-image-wrapper">
                          <img class="car-image" :src="captainDocumentImageUrls.id_card_back" height="100" />
                          <button type="button" class="remove-car-image-button"
                            @click="clearCaptainDocumentSelection('id_card_back')">x</button>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <table class="info-table" v-if="captain && captain.documents && captain.documents.length > 0">
                      <tr>
                        <td><strong>{{ $t("captainProfilePage.profile.document") }}</strong></td>
                        <td><strong>{{ $t("captainProfilePage.profile.action") }}</strong></td>
                      </tr>
                      <tr v-for="doc in captain.documents" :key="doc.id">
                        <td>
                          {{ documentLabel(doc.name) || doc.name }}
                        </td>
                        <td>
                          <a :href="api.GET_IMAGE(doc.path)" target="_blank" rel="noopener noreferrer"
                            style="color: #1976d2; text-decoration: underline; cursor: pointer;">
                            {{ $t("captainProfilePage.profile.view") }}
                          </a>
                        </td>
                      </tr>
                    </table>
                    <div v-else-if="captain" style="color: #8599a3">
                      {{ $t("captainProfilePage.profile.noDocuments") }}
                    </div>
                  </v-flex>
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-btn @click="save" :loading="loading" style="float: inline-end" color="primary">{{ $t("captainProfilePage.profile.save") }}</v-btn>
          </v-card>
        </div>
      </v-tab-item>






      <v-tab :key="2" ripple active-class="tab">{{ $t("captainProfilePage.profile.tabCar") }}</v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-card style="height: 100%; width: 100%; position: absolute">

            <v-layout align-start>
              <v-flex xs6 style="min-height: 100%; margin-inline-start: 100px">
                <v-card-title primary-title>
                  <v-flex xs12>
                    <table class="info-table">

                      <tr>
                        <td>{{ $t("captainProfilePage.profile.vehicleType") }}</td>
                        <td>
                          <!-- Editable for existing cars too (backend UpdateCarRequest accepts
                               vehicle_type): a captain registered as CAR from an APK that still
                               forced a plate can be flipped to MOTORCYCLE here. -->
                          <v-select v-model="editHolder.vehicle_type_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.profile.vehicleType")'
                            :items="vehicleTypeOptions" item-text="label" item-value="value" hide-details>
                          </v-select>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.brand") }}</td>
                        <td>
                          <v-select v-model="editHolder.car_brand_id_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.profile.brand")' :items="carBrands"
                            item-value="id" item-text="name_en" :disabled="!this.editHolder.car_brand_id"
                            :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-select>
                          <div>
                            <button @click="editHolder.car_brand_id = true" v-if="!this.editHolder.car_brand_id">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.car_brand_id = false;
                          editHolder.car_brand_id_value =
                            car.brand_model.car_brand_id;
                          " v-if="this.editHolder.car_brand_id">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.car_brand_id = false" v-if="this.editHolder.car_brand_id">
                            <v-icon>check</v-icon>
                          </button>
                        </td>
                        <td v-if="tmpData && tmpData.brand && !editHolder.car_brand_id_value">
                          {{ tmpData.brand }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.model") }}</td>
                        <td>
                          <v-select v-model="editHolder.car_model_value" style="float: inline-start; width: calc(100% - 128px)"
                            :label='$t("captainProfilePage.profile.model")' :items="carModels" item-value="id" item-text="name_en"
                            :disabled="!this.editHolder.car_model" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-select>
                          <div>
                            <button @click="editHolder.car_model = true" v-if="!this.editHolder.car_model">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.car_model = false;
                          editHolder.car_model_value =
                            car.brand_model_id;
                          " v-if="this.editHolder.car_model">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.car_model = false" v-if="this.editHolder.car_model">
                            <v-icon>check</v-icon>
                          </button>
                        </td>
                        <td v-if="tmpData && tmpData.model && !editHolder.car_model_value">
                          {{ tmpData.model }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.color") }}</td>
                        <td>
                          <v-select v-model="editHolder.color_value" style="float: inline-start; width: calc(100% - 128px)"
                            :label='$t("captainProfilePage.profile.color")' :items="carColors" item-value="id" item-text="name_en"
                            :disabled="!this.editHolder.color" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-select>
                          <div>
                            <button @click="editHolder.color = true" v-if="!this.editHolder.color">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.color = false;
                          editHolder.color_value = car.color;
                          " v-if="this.editHolder.color">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.color = false" v-if="this.editHolder.color">
                            <v-icon>check</v-icon>
                          </button>
                        </td>
                        <td v-if="tmpData && tmpData.color && !editHolder.color_value">
                          {{ tmpData.color }}
                        </td>
                      </tr>

                      <tr>
                        <td>{{ $t("captainProfilePage.profile.plateNumber") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.plate_number_value"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.profile.plateNumber")'
                            :disabled="!this.editHolder.plate_number" :rules="plateRules">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.plate_number = true" v-if="!this.editHolder.plate_number">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.plate_number = false;
                          editHolder.plate_number_value = car.plate_number;
                          " v-if="this.editHolder.plate_number">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.plate_number = false" v-if="this.editHolder.plate_number">
                            <v-icon>check</v-icon>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.manufactureYear") }}</td>
                        <td>
                          <v-text-field v-model="editHolder.manu_year_value" type="number"
                            style="float: inline-start; width: calc(100% - 128px)" :label='$t("captainProfilePage.profile.manufactureYear")'
                            :disabled="!this.editHolder.manu_year" :rules="[(val) => !!val || $t('captainProfilePage.common.required')]">
                          </v-text-field>
                          <div>
                            <button @click="editHolder.manu_year = true" v-if="!this.editHolder.manu_year">
                              <v-icon>edit</v-icon>
                            </button>
                          </div>
                          <button @click="
                            editHolder.manu_year = false;
                          editHolder.manu_year_value = car.car_manufacture_year;
                          " v-if="this.editHolder.manu_year">
                            <v-icon>close</v-icon>
                          </button>
                          <button @click="editHolder.manu_year = false" v-if="this.editHolder.manu_year">
                            <v-icon>check</v-icon>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.carOwnership") }}</td>
                        <td>
                          <v-select
                            :items="ownershipOptions"
                            item-text="label"
                            item-value="value"
                            v-model="editHolder.ownership_type_value"
                            hide-details
                          ></v-select>
                        </td>
                      </tr>
                      <tr v-if="editHolder.ownership_type_value === 'other'">
                        <td>{{ $t("captainProfilePage.profile.carOwner") }}</td>
                        <td>
                          <v-select
                            :items="carOwners"
                            item-text="name"
                            item-value="id"
                            v-model="editHolder.car_owner_id_value"
                            :no-data-text='$t("captainProfilePage.profile.addOwnersHint")'
                            hide-details
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <v-btn @click="
                            saveCarInfo();
                          " color="primary" style="float: inline-end">{{ $t("captainProfilePage.profile.saveCarInfo") }}</v-btn>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-card-title>
              </v-flex>
              <v-flex xs7 style="height: 100%">
                <v-card-title primary-title>
                  <v-flex xs12 style="margin-bottom: 16px">
                    <div class="headline">{{ $t("captainProfilePage.profile.carPicture") }}
                      <input type="file" style="display: none" ref="car_image" accept="image/*" @change="onCarImagePicked" />
                      
                      <button class="upload-button" @click="$refs.car_image.click()">{{ $t("captainProfilePage.profile.changeCarPicture") }}</button>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div>
                      <div class="car-image-wrapper" v-if="carImageUrl">
                        <img class="car-image" :src="carImageUrl" height="100" />
                        <button class="remove-car-image-button" @click="clearCarImageSelection">x</button>
                      </div>
                    </div>
                    <div v-if="car && car.car_picture">
                      <table class="info-table" v-if="car && car.car_picture">
                      <tr>
                        <td><strong>{{ $t("captainProfilePage.profile.document") }}</strong></td>
                        <td><strong>{{ $t("captainProfilePage.profile.action") }}</strong></td>
                      </tr>
                      <tr>
                        <td>{{ $t("captainProfilePage.profile.carPicture") }}</td>
                        <td>
                          <a :href="api.GET_IMAGE(car.car_picture)" target="_blank" rel="noopener noreferrer"
                            style="color: #1976d2; text-decoration: underline; cursor: pointer;">
                            {{ $t("captainProfilePage.profile.view") }}
                          </a>
                        </td>
                      </tr>
                    </table>
                    </div>
                    <div v-else-if="car" style="color: #8599a3">
                      {{ $t("captainProfilePage.profile.noCarPicture") }}
                    </div>
                  </v-flex>
                </v-card-title>
              </v-flex>

            </v-layout>
          </v-card>
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="3" ripple> {{ $t("captainProfilePage.profile.tabTrips") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <DataTable url="captain-bookings" :sortable="false" :enable-edit="false" :enable-add="false"
            :enable-delete="false" :formatter="formatters" :initial-url-search-params="rideSearchParams"
            :actions-extra-main="actionsExtraMain" :fields-hidden-main="[]" :titles="tripsTitles" />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="4" ripple> {{ $t("captainProfilePage.profile.tabPayments") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <CaptainPayments />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="5" ripple>{{ $t("captainProfilePage.profile.tabServices") }}</v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <div>
            <v-layout justify-end class="mb-3">
              <v-btn color="primary" @click="openAddServiceDialog" :disabled="!car">
                {{ $t("captainProfilePage.profile.addService") }}
              </v-btn>
            </v-layout>
            <DataTable :url="`captain/${$route.params.id}/services`" :sortable="false" :enable-edit="false"
              :enable-add="false" :enable-delete="false" :formatter="servicesFormatter"
              :actions-extra-main="servicesActions"
              :fields-hidden-main="['deleted_at', 'created_at', 'updated_at', 'name_ar', 'icon', 'priority', 'pivot', 'info']"
              :titles="servicesTitles" :title="false" :key="servicesReloadKey" />
          </div>
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="6" ripple> {{ $t("captainProfilePage.common.rating") }} </v-tab>

      <v-tab-item>
        <Ratings />
      </v-tab-item>

      <v-tab active-class="tab" :key="7" ripple> {{ $t("captainProfilePage.shiftLogs.tabTitle") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <ShiftLogs :captain-id="Number($route.params.id)" />
        </div>
      </v-tab-item>


    </v-tabs>

    <!-- Add Service Dialog -->
    <v-dialog v-model="addServiceDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("captainProfilePage.profile.addService") }}</span>
        </v-card-title>
        <v-card-text>
          <v-select v-model="selectedService" :items="availableServices" item-text="name_en" item-value="id"
            :label='$t("captainProfilePage.profile.selectService")' :loading="loadingServices"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="addServiceDialog = false">{{ $t("captainProfilePage.common.cancel") }}</v-btn>
          <v-btn color="blue darken-1" flat @click="addService" :loading="addingService">{{ $t("captainProfilePage.profile.add") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { companyNow, formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";
import CaptainPayments from "@/views/captains/CaptainPayments";
import Ratings from "@/components/profile/captain/Ratings";
import ShiftLogs from "@/components/profile/captain/ShiftLogs";
import WelcomeBonusCard from "@/components/profile/captain/WelcomeBonusCard";
import { ACCOUNT_STATE_COLORS, BAN_NOTE_MAX, isAccountState } from "@/constants/accountState";

// Owner item 3.1: the ban endpoint answers in plain English; these are the
// failures it can name, everything else gets the generic translated toast.
const BAN_ERROR_KEYS = Object.freeze({
  "captain has active ride": "accountState.activeRide",
  "Already blocked": "accountState.alreadyBlocked",
});

export default {
  name: "CaptainProfile",
  title: "captainProfilePage.profile.pageTitle",
  components: {
    LoadingComponent,
    DataTable,
    CaptainPayments,
    Ratings,
    ShiftLogs,
    WelcomeBonusCard

  },

  data() {
    return {
      registerLoading: false,
      colors: {
        rating: {
          1: "red",
          2: "orange",
          3: "yellow",
          4: "green",
          5: "forestgreen",
        },
      },

      complaintsKey: 0,
      active: 0,
      switch1: false,
      vSwitchLoading: false,
      blackListed: false,
      dailyBlackListed: false,
      carColors: [],

      log: "",
      active_el: 0,

      captain: "",
      // Welcome bonus (doc 28-8): admin's per-captain override, in DISPLAY
      // (new-unit) SYP; converted with toStoredAmount() before the accept POST.
      welcomeBonusInput: null,
      // Owner item 2.1: CAPTAIN_WELCOME_BONUS_MAX in STORED old-unit SYP
      // (0 = no ceiling, or not readable without the SETTINGS permission).
      welcomeBonusMax: 0,
      captain_docs: "",
      car_docs: "",
      captain_constraints: [],
      captain_static_constraints: [],
      driver_constraints: [],
      cars: "",
      car: "",
      imageName: "",
      imageUrl: "",
      imageFile: "",
      carOwners: [],
      captainDocumentFiles: {
        lisence_photo_front: "",
        lisence_photo_back: "",
        id_card_front: "",
        id_card_back: "",
      },
      captainDocumentImageUrls: {
        lisence_photo_front: "",
        lisence_photo_back: "",
        id_card_front: "",
        id_card_back: "",
      },
      carImage: "",
      carImageName: "",
      carImageUrl: "",
      carImageFile: "",
      data: [],
      loading: false,
      totalItems: 0,

      uploading: false,
      carLoading: false,
      dialog: false,
      selectedCarId: 0,
      editHolder: {
        vehicle_type: false,
        // CAR | MOTORCYCLE: seeded from the stored car (mounted) or picked for a new one.
        vehicle_type_value: "CAR",
        car_model: false,
        car_model_value: "",
        plate_number: false,
        plate_number_value: "",
        has_owner: false,
        has_owner_value: false,
        ownership_type_value: "driver",
        car_owner_id_value: null,
        car_brand_id: false,
        car_brand_id_value: "",
        color: false,
        color_value: "",
        manu_year: false,
        manu_year_value: "",
        username: false,
        first_name: false,
        first_name_value: "",
        last_name: false,
        last_name_value: "",
        username: false,
        username_value: "",
        email: false,
        email_value: "",
        gender: false,
        gender_value: "",
        type: false,
        type_value: "",
      },
      tmpData: null,
      carModels: [],
      vehicleTypes: [],
      carBrands: [],
      isSuperAdmin: false,
      formatters: {
        booking_time(value) {
          return formatCompanyTime(value, "DD-MM-YYYY  HH:mm");
        },
      },
      captainServices: [],
      availableServices: [],
      addServiceDialog: false,
      selectedService: null,
      loadingServices: false,
      addingService: false,
      servicesReloadKey: 0,
    };
  },
  created() {
    this.$store.state.user.roles.forEach((role) => {
      if (role.name === "Super Admin") {
        this.isSuperAdmin = true;
      } else {
        this.isSuperAdmin = false;
      }
    });


  },
  mounted() {
    const tabFromQuery = this.$route.query.tab;
    if (tabFromQuery) {
      this.active = parseInt(tabFromQuery);
    }
    this.axios.get(`captain/${this.$route.params.id}`).then(({ data }) => {
      this.blackListed = data.data.blacklisted_at ? true : false;

      this.captain = data.data;
      // A captain may have registered without a car yet (car is null). Guard
      // every car.* access below so mounted() doesn't abort — otherwise the
      // car-owners list never loads and the Save button silently throws.
      this.car = this.captain.car || null;

      // Welcome bonus (doc 28-8): pre-fill the pending input in DISPLAY units
      // (stored old-unit / 100). A stored per-captain value wins over the
      // default the backend appends for pending captains.
      if (!this.captain.approved_at && this.captain.welcome_bonus_enabled) {
        const storedBonus =
          this.captain.welcome_bonus != null
            ? this.captain.welcome_bonus
            : this.captain.welcome_bonus_default;
        this.welcomeBonusInput = storedBonus != null ? storedBonus / 100 : 0;
        this.loadWelcomeBonusMax();
      }

      console.log("Captain documents:", this.captain.documents);


      this.editHolder.first_name_value = data.data.first_name;
      this.editHolder.last_name_value = data.data.last_name;

      this.editHolder.username_value = data.data.username;
      this.editHolder.email_value = data.data.email;
      this.editHolder.gender_value = data.data.gender;
      this.editHolder.type_value = data.data.type;

      // Always load the car owners (this used to sit after the car.* reads, so
      // a null car aborted it and the ownership picker came up empty).
      this.axios
        .get("car-owner", { params: { perPage: 1000 } })
        .then((res) => {
          this.carOwners = (res.data.data && res.data.data.data) || [];
        })
        .catch(() => {});

      if (this.car) {
        this.editHolder.vehicle_type_value = this.car.vehicle_type || "CAR";
        this.editHolder.plate_number_value = this.car.plate_number;
        this.editHolder.has_owner_value = this.car.has_owner;
        this.editHolder.ownership_type_value =
          this.car.ownership_type || (this.car.has_owner ? "company" : "driver");
        this.editHolder.car_owner_id_value = this.car.car_owner_id || null;
        this.editHolder.car_brand_id_value = this.car.brand_model ? this.car.brand_model.car_brand_id : "";
        this.editHolder.color_value = this.car.color_id || "";
        this.editHolder.manu_year_value = this.car.car_manufacture_year;

        if (this.car.temp_data) {
          this.tmpData = this.car.temp_data;
          console.log(this.tmpData);
        }
      } else {
        // No car yet: default the ownership so the picker is usable, and open
        // the fields for editing so the admin can create the car right away.
        this.editHolder.ownership_type_value = "driver";
        this.editHolder.car_brand_id = true;
        this.editHolder.car_model = true;
        this.editHolder.color = true;
        this.editHolder.plate_number = true;
        this.editHolder.manu_year = true;
      }



      this.loading = false;
    });

    // Load captain services
    this.loadCaptainServices();

    this.axios
      .get("car-brand", {
        perPage: 1000,
      })
      .then(({ data }) => {
        this.carBrands = data.data.data;
      });
    this.axios
      .get("color", {
        perPage: 1000,
      })
      .then(({ data }) => {
        this.carColors = data.data.data;
      });
    // this.axios 
    //   .get(`document/captain/${this.$route.params.id}`)
    //   .then(({ data }) => {
    //     this.captain_docs = data.data;
    //     // console.log('captain docs');
    //     // console.log(this.captain_docs);
    //   });

  },
  watch: {
    "editHolder.car_brand_id_value": function (val) {
      if (!val)
        return;
      this.axios
        .get(`car-brand/${val}/models?perPage=100`, {
          perPage: 1000,
        })
        .then((models) => {
          this.carModels = models.data.data.data;
          // Re-select the saved model only when a car exists; for a car being
          // created there is nothing to pre-select (and this.car is null).
          if (this.car) {
            this.editHolder.car_model_value = this.car.brand_model_id;
          }
        });
    },
  },
  methods: {
    clearCarImageSelection() {
      this.carImageName = "";
      this.carImageFile = "";
      this.carImageUrl = "";
      if (this.$refs.car_image) {
        this.$refs.car_image.value = "";
      }
    },

    onCarImagePicked(e) {

      const files = e.target.files;
      if (files[0] !== undefined) {
        this.carImageName = files[0].name;
        if (this.carImageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.carImageUrl = fr.result;
          this.carImageFile = files[0];

        });
      } else {
        this.carImageName = "";
        this.carImageFile = "";
        this.carImageUrl = "";
      }
    },

    documentLabel(name) {
      const map = {
        lisence_photo_front: this.$t("captainProfilePage.profile.licenseFront"),
        lisence_photo_back: this.$t("captainProfilePage.profile.licenseBack"),
        id_card_front: this.$t("captainProfilePage.profile.idCardFront"),
        id_card_back: this.$t("captainProfilePage.profile.idCardBack"),
      };
      return map[name] || name;
    },
    triggerCaptainDocumentUpload(documentKey) {
      const refsMap = {
        lisence_photo_front: "lisence_photo_front_input",
        lisence_photo_back: "lisence_photo_back_input",
        id_card_front: "id_card_front_input",
        id_card_back: "id_card_back_input",
      };
      const inputRef = refsMap[documentKey];
      if (inputRef && this.$refs[inputRef]) {
        this.$refs[inputRef].click();
      }
    },
    onCaptainDocumentPicked(e, documentKey) {
      const files = e.target.files;
      if (files && files[0] !== undefined) {
        const file = files[0];
        if (file.name.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener("load", () => {
          this.captainDocumentFiles[documentKey] = file;
          this.captainDocumentImageUrls[documentKey] = fr.result;
        });
      } else {
        this.clearCaptainDocumentSelection(documentKey);
      }
    },
    clearCaptainDocumentSelection(documentKey) {
      this.captainDocumentFiles[documentKey] = "";
      this.captainDocumentImageUrls[documentKey] = "";
      const refsMap = {
        lisence_photo_front: "lisence_photo_front_input",
        lisence_photo_back: "lisence_photo_back_input",
        id_card_front: "id_card_front_input",
        id_card_back: "id_card_back_input",
      };
      const inputRef = refsMap[documentKey];
      if (inputRef && this.$refs[inputRef]) {
        this.$refs[inputRef].value = "";
      }
    },

    // Owner item 3.1: blocking asks for confirmation and an optional note
    // (stored in blacklist_note); unblocking acts at once, as before.
    blockCaptain(value) {
      if (!value) {
        this.sendBlacklist(false, "", null);
        return;
      }
      this.$dialova({
        title: this.$t("accountState.blockTitle"),
        paragraph: this.$t("accountState.blockCaptainConfirm"),
        input: this.$t("accountState.notePlaceholder"),
        maxlength: BAN_NOTE_MAX,
        loader: true,
      })
        .then(({ close, value: note }) => {
          this.sendBlacklist(true, String(note || "").trim().slice(0, BAN_NOTE_MAX), close);
        })
        .catch(() => {
          // Dialog dismissed: nothing was sent, put the switch back.
          this.blackListed = false;
        });
    },
    sendBlacklist(block, note, close) {
      const body = {};
      if (block && note) body.note = note;
      this.vSwitchLoading = true;
      this.axios
        .post(`captain/${this.$route.params.id}/${block ? "blacklist" : "un_blacklist"}`, body)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t(block ? "accountState.blocked" : "accountState.unblocked"),
            "green"
          );
          return this.refreshAccountState(block, note);
        })
        .catch((err) => {
          const message = err && err.response && err.response.data && err.response.data.message;
          const key =
            message && Object.prototype.hasOwnProperty.call(BAN_ERROR_KEYS, message)
              ? BAN_ERROR_KEYS[message]
              : "accountState.blockFailed";
          window.getApp.$emit("SHOW_TOAST", this.$t(key), "red");
          if (message === "Already blocked") {
            // Someone else banned this driver: show the server's state, not a
            // revert. A null note keeps the unsent note off the other ban.
            this.blackListed = true;
            return this.refreshAccountState(true, null);
          }
          this.blackListed = !block;
        })
        .finally(() => {
          this.vSwitchLoading = false;
          if (close) close();
        });
    },
    // Owner item 3.1: re-read the driver after a ban toggle so the state chip
    // is the server's (only the backend knows whether an unbanned driver is
    // active or inactive). Never rejects: the toggle itself already succeeded.
    refreshAccountState(block, note) {
      return this.axios
        .get(`captain/${this.$route.params.id}`)
        .then(({ data }) => {
          const fresh = (data && data.data) || {};
          ["account_state", "blacklisted_at", "blacklist_note"].forEach((key) =>
            this.$set(this.captain, key, fresh[key])
          );
        })
        .catch(() => {
          this.$set(this.captain, "account_state", block ? "banned" : undefined);
          this.$set(this.captain, "blacklisted_at", block ? new Date().toISOString() : null);
          this.$set(this.captain, "blacklist_note", block ? note || null : null);
        });
    },

    ellipsify(str) {
      if (str.length > 10) {
        return str.substring(0, 10) + "...";
      } else {
        return str;
      }
    },
    expandTable(row) {
      row.expanded = !row.expanded;
    },
    showDetails(title, id) {
      this.axios.get(`complaint/${id}/audio`).then((res) => {
        this.$dialova({
          title: title,
          hideCancel: true,
          list: res.data.data,
          additionalData: {
            id: id,
          },
        })
          .then(() => { })
          .catch(() => { });
      });
    },

    saveDriverConstraints() {
      // this.editHolder
      this.uploading = true;
      this.dialog = true;

      this.axios
        .post("dynamic_constraints/editCaptainConstraint", {
          captainId: this.$route.params.id,
          static_cons: this.captain_static_constraints,
          dynamic_cons: this.captain_constraints,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.constraintsSaved"), "green");
          // this.$router.push("/captains");
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.checkYourInfo"), "red");
          }
        })
        .then(() => {
          this.uploading = false;
          this.dialog = false;
        });
    },

    saveCarInfo() {
      // Update an existing car, or CREATE one for a captain who registered
      // without a car (car === null). Without this branch the old code posted
      // to `car/${null.id}` and threw silently — no request, no message.
      const existingCar = this.captain.car && this.captain.car.id;

      const updatedData = [];
      if (this.carImageFile)
        updatedData.push({ car_picture: this.carImageFile });

      if (this.editHolder.car_model_value)
        updatedData.push({
          brand_model_id: this.editHolder.car_model_value,
        });

      // The type always travels (UpdateCarRequest: sometimes|in) so an existing
      // car can be flipped and required_unless sees it next to the plate.
      updatedData.push({ vehicle_type: this.editHolder.vehicle_type_value || "CAR" });

      if (this.editHolder.plate_number_value) {
        updatedData.push({
          plate_number: this.editHolder.plate_number_value,
        });
      } else if (existingCar) {
        // A car keeps a mandatory plate; a motorcycle may drop it: send '' so
        // the backend (ConvertEmptyStringsToNull + nullable) clears a
        // placeholder plate instead of silently keeping it.
        if (!this.isMotorcycle) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("captainProfilePage.profile.plateNumber") +
              ": " +
              this.$t("captainProfilePage.common.required"),
            "red"
          );
          return;
        }
        updatedData.push({ plate_number: "" });
      }

      if (this.editHolder.color_value)
        updatedData.push({
          color_id: this.editHolder.color_value,
        });

      if (this.editHolder.manu_year_value)
        updatedData.push({
          car_manufacture_year: this.editHolder.manu_year_value,
        });

      // Ownership: the backend normalizes has_owner and clears the owner
      // link unless the type is 'other'.
      const ownership = this.editHolder.ownership_type_value || "driver";
      updatedData.push({ ownership_type: ownership });
      if (ownership === "other" && this.editHolder.car_owner_id_value)
        updatedData.push({ car_owner_id: this.editHolder.car_owner_id_value });

      if (ownership === "other" && !this.editHolder.car_owner_id_value) {
        window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.pickCarOwner"), "red");
        return;
      }

      // Creating a new car needs the full identity up front (the backend
      // StoreCarRequest requires them); updating can be partial.
      if (!existingCar) {
        const missing = [];
        if (!this.editHolder.car_model_value) missing.push(this.$t("captainProfilePage.profile.model"));
        // Motorcycles may have no plate (backend: required_unless MOTORCYCLE).
        if (!this.isMotorcycle && !this.editHolder.plate_number_value)
          missing.push(this.$t("captainProfilePage.profile.plateNumber"));
        if (!this.editHolder.color_value) missing.push(this.$t("captainProfilePage.profile.color"));
        if (!this.editHolder.manu_year_value) missing.push(this.$t("captainProfilePage.profile.manufactureYear"));
        if (missing.length) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("captainProfilePage.profile.noCarYetFill", { fields: missing.join(", ") }),
            "red"
          );
          return;
        }
      }

      const formData = new FormData();
      if (existingCar) {
        formData.append("_method", "PUT");
      } else {
        formData.append("captain_id", this.captain.id);
      }
      for (const field of updatedData) {
        const key = Object.keys(field)[0];
        formData.append(key, field[key]);
      }

      const url = existingCar ? `car/${this.captain.car.id}` : `car`;
      this.axios
        .post(url, formData)
        .then(({ data }) => {
          window.getApp.$emit(
            "SHOW_TOAST",
            existingCar
              ? this.$t("captainProfilePage.profile.savedSuccessfully")
              : this.$t("captainProfilePage.profile.carCreated"),
            "green"
          );
          this.carImageName = "";
          this.carImageFile = "";
          this.carImageUrl = "";
          this.car = data.data;
          // Reflect the stored type (the operator may have flipped it)
          if (data.data && data.data.vehicle_type)
            this.editHolder.vehicle_type_value = data.data.vehicle_type;
          // Keep captain.car in sync so a follow-up save updates (PUT) instead
          // of trying to create the same car again.
          this.$set(this.captain, "car", data.data);
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit(
              "SHOW_TOAST",
              (response.data && response.data.message) || this.$t("captainProfilePage.profile.checkYourInfo"),
              "red"
            );
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.checkYourInfo"), "red");
          }
        });
    },


    openImage(value) {
      // console.log(value);

      window.open(this.api.GET_IMAGE(value.path), "_blank");
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    loadCaptainServices() {
      // Force reload DataTable by incrementing key
      this.servicesReloadKey += 1;
    },

    openAddServiceDialog() {
      this.addServiceDialog = true;
      this.selectedService = null;
      this.loadingServices = true;
      // Get current captain services to filter them out
      this.axios
        .get(`captain/${this.$route.params.id}/services`, { perPage: 1000 })
        .then(({ data: captainData }) => {
          const attachedServiceIds = (captainData.data.data || captainData.data || []).map(s => s.id);
          // Get all services
          return this.axios.get("service", { perPage: 1000 }).then(({ data }) => {
            this.availableServices = (data.data.data || data.data || []).filter(
              service => !attachedServiceIds.includes(service.id)
            );
            this.loadingServices = false;
          });
        })
        .catch((err) => {
          console.error("Error loading services:", err);
          window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.failedLoadServices"), "red");
          this.loadingServices = false;
        });
    },

    addService() {
      if (!this.selectedService) {
        window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.pleaseSelectService"), "red");
        return;
      }
      this.addingService = true;
      this.axios
        .post(`captain/${this.$route.params.id}/services`, {
          service_id: this.selectedService
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.serviceAdded"), "green");
          this.addServiceDialog = false;
          this.servicesReloadKey += 1; // Trigger DataTable reload
          this.addingService = false;
        })
        .catch((err) => {
          console.error("Error adding service:", err);
          window.getApp.$emit(
            "SHOW_TOAST",
            (err.response && err.response.data && err.response.data.message) || this.$t("captainProfilePage.profile.failedAddService"),
            "red"
          );
          this.addingService = false;
        });
    },

    deleteService(serviceId) {
      const itemName = this.$t("captainProfilePage.profile.thisService");
      this.$dialova({
        title: this.$t("captainProfilePage.profile.deleteConfirmation"),
        paragraph: this.$t("captainProfilePage.profile.deleteConfirmText", { name: itemName }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .delete(`captain/${this.$route.params.id}/services/${serviceId}`)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.serviceRemoved"), "green");
              this.servicesReloadKey += 1; // Trigger DataTable reload
              close();
            })
            .catch((err) => {
              console.error("Error deleting service:", err);
              window.getApp.$emit(
                "SHOW_TOAST",
                (err.response && err.response.data && err.response.data.message) || this.$t("captainProfilePage.profile.failedRemoveService"),
                "red"
              );
              close();
            });
        })
        .catch(() => {
          // User cancelled
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loading = false;
        const updatedData = [];
        if (this.imageFile)
          updatedData.push({ profile_image: this.imageFile });
        if (this.captainDocumentFiles.lisence_photo_front)
          updatedData.push({ lisence_photo_front: this.captainDocumentFiles.lisence_photo_front });
        if (this.captainDocumentFiles.lisence_photo_back)
          updatedData.push({ lisence_photo_back: this.captainDocumentFiles.lisence_photo_back });
        if (this.captainDocumentFiles.id_card_front)
          updatedData.push({ id_card_front: this.captainDocumentFiles.id_card_front });
        if (this.captainDocumentFiles.id_card_back)
          updatedData.push({ id_card_back: this.captainDocumentFiles.id_card_back });

        if (this.editHolder.first_name_value)
          updatedData.push({
            first_name: this.editHolder.first_name_value,
          });
        if (this.editHolder.last_name_value)
          updatedData.push({
            last_name: this.editHolder.last_name_value,
          });
        if (this.editHolder.username_value)
          updatedData.push({
            username: this.editHolder.username_value,
          });
        if (this.editHolder.email_value)
          updatedData.push({
            email: this.editHolder.email_value,
          });
        if (this.editHolder.gender_value !== "")
          updatedData.push({
            gender: this.editHolder.gender_value,
          });
        if (this.editHolder.type_value !== "")
          updatedData.push({
            type: this.editHolder.type_value,
          });

        if (updatedData.length > 0) {
          this.loading = true;
          const formData = new FormData();
          formData.append("_method", "PUT");
          for (const field of updatedData) {
            const key = Object.keys(field)[0];
            formData.append(key, field[key]);
          }
          this.axios
            .post(this.api.ACTIONS.CAPTAINS + "/" + this.$route.params.id, formData)
            .then(({ data }) => {
              this.imageName = "";
              this.imageFile = "";
              this.imageUrl = "";
              this.captainDocumentFiles.lisence_photo_front = "";
              this.captainDocumentFiles.lisence_photo_back = "";
              this.captainDocumentFiles.id_card_front = "";
              this.captainDocumentFiles.id_card_back = "";
              this.captainDocumentImageUrls.lisence_photo_front = "";
              this.captainDocumentImageUrls.lisence_photo_back = "";
              this.captainDocumentImageUrls.id_card_front = "";
              this.captainDocumentImageUrls.id_card_back = "";
              if (this.$refs.lisence_photo_front_input) this.$refs.lisence_photo_front_input.value = "";
              if (this.$refs.lisence_photo_back_input) this.$refs.lisence_photo_back_input.value = "";
              if (this.$refs.id_card_front_input) this.$refs.id_card_front_input.value = "";
              if (this.$refs.id_card_back_input) this.$refs.id_card_back_input.value = "";
              this.captain = data.data;
              window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.saved"));
            })
            .catch(({ response }) => {
              if (response && response.data && response.data.message)
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("captainProfilePage.profile.somethingWentWrong"),
                  "red"
                );
                console.log(data);
              }
            }).finally(() => (this.loading = false));
        }
      } else {
        window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.pleaseCheckAllFields"), "red");
      }
    },
    register() {
      let captain_id = this.$route.params.id;
      // Welcome bonus (doc 28-8): send the admin's override back in STORED
      // old-unit SYP. Omit the key entirely when the feature flag is off so
      // the backend keeps its own default behavior. Owner item 2.1: omit it
      // too for a user without WELCOME_BONUS_MANAGE (the field is read-only
      // for him); the backend then grants the stored amount or the default,
      // and would refuse any other amount from him.
      const body = {};
      if (this.captain.welcome_bonus_enabled && this.canSetWelcomeBonus) {
        const overrideError = this.welcomeBonusOverrideError(this.welcomeBonusInput);
        if (overrideError) {
          window.getApp.$emit("SHOW_TOAST", overrideError, "red");
          return;
        }
        const storedBonus = this.toStoredAmount(this.welcomeBonusInput);
        if (storedBonus != null) body.welcome_bonus = storedBonus;
      }
      this.registerLoading = true;
      this.axios
        .post(`captain/${captain_id}/accept`, body)
        .then(({ data }) => {
          console.log(data)
          this.captain = data.data;
          window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.profile.captainAccepted"));
          // Owner item 2.1: the accept answer is the bare captain row; fetch
          // the restricted balance summary so its card shows at once.
          if (this.captain && this.captain.welcome_bonus_granted_at) this.loadWelcomeBonusSummary();
        })
        .catch(({ response }) => {
          if (response && response.data && response.data.message)
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          else {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("captainProfilePage.profile.somethingWentWrong"),
              "red"
            );
            console.log(data);
          }
        }).finally(() => (this.registerLoading = false));
    },
    // Owner item 2.1: the approval-time amount must be a whole OLD-unit
    // amount once stored, like the backend's integer rule, i.e. at most two
    // decimals in display units (a default such as 10050 shows 100.5), and at most
    // CAPTAIN_WELCOME_BONUS_MAX when that ceiling is set. Empty = the stored
    // per-captain amount or the default, as before. null when valid.
    welcomeBonusOverrideError(value) {
      const text = value === null || value === undefined ? "" : String(value).trim();
      if (text === "") return null;
      if (!/^\d+(\.\d{1,2})?$/.test(text)) return this.$t("captainProfilePage.welcomeBonus.overrideWhole");
      if (this.welcomeBonusMax > 0 && this.toStoredAmount(text) > this.welcomeBonusMax) {
        return this.$t("captainProfilePage.welcomeBonus.overrideAboveMax", {
          max: this.formatMoney(this.welcomeBonusMax),
        });
      }
      return null;
    },
    // Owner item 2.1: the ceiling lives in the settings, which only a SETTINGS
    // user may read; without it the backend's own max check (and message)
    // stays the guard.
    loadWelcomeBonusMax() {
      if (!this.canSetWelcomeBonus || !this.hasPermission("SETTINGS")) return;
      this.axios
        .get("setting")
        .then(({ data }) => {
          const max = parseInt(((data && data.data) || {}).CAPTAIN_WELCOME_BONUS_MAX, 10);
          this.welcomeBonusMax = max > 0 ? max : 0;
        })
        .catch(() => {});
    },
    loadWelcomeBonusSummary() {
      this.axios
        .get(this.api.ACTIONS.CAPTAIN_WELCOME_BONUS(this.$route.params.id))
        .then(({ data }) => {
          const payload = (data && data.data) || {};
          if (payload.summary !== undefined) this.onWelcomeBonusSummary(payload.summary);
        })
        .catch(() => {});
    },
    onWelcomeBonusSummary(summary) {
      if (this.captain && typeof this.captain === "object") {
        this.$set(this.captain, "welcome_bonus_summary", summary);
      }
    },
    isValid() {
      console.log("isActive");
      return false;
    },
  },
  computed: {
    blackListedTag() {
      return this.blackListed
        ? this.$t("captainProfilePage.profile.unblock")
        : this.$t("captainProfilePage.profile.block");
    },
    // Owner item 3.1: active / inactive / banned as the server computed it
    // (findCaptain carries account_state; an older payload shows no chip).
    captainAccountState() {
      const state = this.captain && this.captain.account_state;
      return isAccountState(state) ? state : null;
    },
    captainAccountStateColor() {
      return this.captainAccountState ? ACCOUNT_STATE_COLORS[this.captainAccountState] : null;
    },
    // Owner item 2.1: an amount other than the default is a finance decision
    // (the backend asks WELCOME_BONUS_MANAGE for it).
    canSetWelcomeBonus() {
      return this.hasPermission("WELCOME_BONUS_MANAGE");
    },
    welcomeBonusRules() {
      if (!this.canSetWelcomeBonus) return [];
      return [(v) => this.welcomeBonusOverrideError(v) || true];
    },
    welcomeBonusInputHint() {
      const restricted = this.$t("captainProfilePage.profile.welcomeBonusHint");
      let detail;
      if (!this.canSetWelcomeBonus) {
        detail = this.$t("captainProfilePage.welcomeBonus.overrideNeedsPermission");
      } else if (this.welcomeBonusMax > 0) {
        detail = this.$t("captainProfilePage.welcomeBonus.overrideHintMax", {
          max: this.formatMoney(this.welcomeBonusMax),
        });
      } else {
        detail = this.$t("captainProfilePage.welcomeBonus.overrideHint");
      }
      return `${restricted} - ${detail}`;
    },
    dailyblackListedTag() {
      return this.dailyBlackListed
        ? this.$t("captainProfilePage.profile.unblockDaily")
        : this.$t("captainProfilePage.profile.blockDaily");
    },
    vehicleTypeOptions() {
      return [
        { label: this.$t("captainProfilePage.profile.vehicleTypeCar"), value: "CAR" },
        { label: this.$t("captainProfilePage.profile.vehicleTypeMotorcycle"), value: "MOTORCYCLE" },
      ];
    },
    // The type currently selected in the form (seeded from the stored car in
    // mounted, or picked for the car about to be created).
    isMotorcycle() {
      const type =
        this.editHolder.vehicle_type_value || (this.car ? this.car.vehicle_type : "CAR");
      return type === "MOTORCYCLE";
    },
    // A plate is mandatory for cars only (backend: plate_number
    // required_unless vehicle_type MOTORCYCLE).
    plateRules() {
      if (this.isMotorcycle) return [];
      return [(val) => !!val || this.$t("captainProfilePage.common.required")];
    },
    ownershipOptions() {
      return [
        { label: this.$t("captainProfilePage.profile.ownershipDriver"), value: "driver" },
        { label: this.$t("captainProfilePage.profile.ownershipCompany"), value: "company" },
        { label: this.$t("captainProfilePage.profile.ownershipOther"), value: "other" },
      ];
    },
    genders() {
      return [
        { text: this.$t("captainProfilePage.profile.male"), value: 1 },
        { text: this.$t("captainProfilePage.profile.female"), value: 0 },
      ];
    },
    types() {
      return [
        { text: this.$t("captainProfilePage.profile.typeInternal"), value: "internal" },
        { text: this.$t("captainProfilePage.profile.typeExternal"), value: "external" },
      ];
    },
    titles() {
      return {
        id: "#",
        start_datetime: this.$t("captainProfilePage.common.date"),
        pick_up_location_name: this.$t("captainProfilePage.common.pickUpLocation"),
        drop_off_location_name: this.$t("captainProfilePage.common.dropOffLocation"),
        passenger_name: this.$t("captainProfilePage.common.passenger"),
        meter_price: this.$t("captainProfilePage.common.price"),
        captain_rating: this.$t("captainProfilePage.common.rating"),
        from_datetime: this.$t("captainProfilePage.common.datetime"),
        status: this.$t("captainProfilePage.common.status"),
        station_id: this.$t("captainProfilePage.common.stationId"),
      };
    },
    logTitles() {
      return {
        id: this.$t("captainProfilePage.common.logId"),
        start_datetime: this.$t("captainProfilePage.common.date"),
        from_datetime: this.$t("captainProfilePage.common.datetime"),
        status: this.$t("captainProfilePage.common.status"),
        station_id: this.$t("captainProfilePage.common.stationId"),
      };
    },
    changeNameTitles() {
      return {
        id: this.$t("captainProfilePage.common.id"),
        first_name: this.$t("captainProfilePage.common.firstName"),
        last_name: this.$t("captainProfilePage.common.lastName"),
        created_at: this.$t("captainProfilePage.profile.changeTime"),
      };
    },
    tripsTitles() {
      return {
        booking_id: this.$t("captainProfilePage.common.bookingId"),
        booking_time: this.$t("captainProfilePage.common.date"),
        pickup_name: this.$t("captainProfilePage.common.pickUpLocation"),
        dropdown_name: this.$t("captainProfilePage.common.dropOffLocation"),
        passenger_name: this.$t("captainProfilePage.profile.clientName"),

      };
    },
    rideSearchParams() {
      const params = new URLSearchParams();
      params.append("captain_id", this.$route.params.id);
      return params;
    },
    today() {
      return companyNow().format("YYYY-MM-DD");
    },
    actionsExtraMain() {
      return {
        details: {
          title: this.$t("captainProfilePage.common.orderDetails"),
          icon: "map",
          action: (item) => {
            const route = this.$router.resolve({
              name: "Bookings",
              params: {
                id: item.booking_id
              },
            });
            window.open(route.href, '_blank');
          }

        },
      };
    },
    servicesTitles() {
      return {
        id: "#",
        name_en: this.$t("captainProfilePage.profile.serviceName"),
        active: this.$t("captainProfilePage.profile.active")
      };
    },
    servicesFormatter() {
      return {
        active: (val) => {
          return val ? '<i class="v-icon fa fa-check"></i>' : '<i class="v-icon fa fa-close"></i>';
        }
      };
    },
    servicesActions() {
      const self = this;
      return {
        delete: {
          title: self.$t("captainProfilePage.common.delete"),
          icon: "delete",
          color: "error",
          action: (item) => {
            const itemName =
              item.name_en || item.name_ar || item.name || self.$t("captainProfilePage.profile.thisService");
            return self
              .$dialova({
                title: self.$t("captainProfilePage.profile.deleteConfirmation"),
                paragraph: self.$t("captainProfilePage.profile.deleteConfirmText", { name: itemName }),
                loader: true,
              })
              .then(({ close }) => {
                return self.axios
                  .delete(`captain/${self.$route.params.id}/services/${item.id}`)
                  .then(() => {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      self.$t("captainProfilePage.profile.serviceRemoved"),
                      "green"
                    );
                    self.servicesReloadKey += 1; // Trigger DataTable reload
                    close();
                  })
                  .catch((err) => {
                    console.error("Error deleting service:", err);
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      (err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                      self.$t("captainProfilePage.profile.failedRemoveService"),
                      "red"
                    );
                    close();
                  });
              })
              .catch(() => {
                // user cancelled
              });
          },
        },
      };
    },
  },

  formatter() {
    return {
      // created_at(value) {
      //   return moment(value).format(" DD MMM YYYY");
      // },

      active(val) {
        //language=HTML
        return `
                      <i class="v-icon fa ${val ? "fa-check" : "fa-close"}"></i>
                      `;
      },
    };
  },
};
</script>

<style scoped>
.strike_through {
  text-decoration-line: line-through
}

.not-treated {
  td {
    background-color: rgba(220, 39, 39, 0.08);
    border-radius: 4px;
    color: rgb(220, 39, 39);
  }
}

.treated {
  td {
    background-color: rgba(99, 228, 24, 0.08);
    border-radius: 4px;
    color: rgb(5, 116, 51);
  }
}

.partially-treated {
  td {
    background-color: rgba(252, 179, 45, 0.08);
    border-radius: 4px;
    color: rgb(252, 179, 45);
  }
}

.body {
  background-color: #ffffff !important;
}

.docs:hover {
  cursor: pointer;
}

.star {
  color: #f3c220;
}

.ban-note {
  color: #8599a3;
  font-size: 12px;
  margin-top: 4px;
  overflow-wrap: anywhere;
}

.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-inline-end: 17px;
  margin-top: 10px;
}

.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.captains-list {
  width: 100%;
  margin-inline-start: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: inline-start;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.captain {
  width: max-content;
  float: inline-start;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: inline-start;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}

.open {
  margin-bottom: 15px;
  margin-inline-start: 35px;
}

.constraints.v-label {
  font-size: xx-large !important;
}

.info-table {
  border-collapse: collapse;
  width: 100%;
}

.info-table td:not(:first-child) {
  padding: 12px;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
.upload-button {
  float: inline-end;
  border:none;
  background-color: transparent;
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-size: medium;
}
.car-image-wrapper {
  position: relative;
  float: inline-end;
}

.car-image {
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.remove-car-image-button {
  position: absolute;
  top: 6px;
  inset-inline-end: 6px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.65);
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
  line-height: 22px;
}
.captain-doc-upload-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.upload-button-inline {
  border: none;
  background-color: transparent;
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}
.captain-doc-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.captain-doc-preview-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.captain-doc-preview-label {
  color: #5b6b73;
  font-size: 13px;
}
</style>
